"use strict";
/**
 * --------------------------------------------------------------------------
 * DiceBear (@dicebear/avatars)
 *
 * Code licensed under MIT (https://github.com/dicebear/dicebear/blob/v4/packages/avatars/LICENSE)
 * Copyright (c) 2021 Florian Körner
 * --------------------------------------------------------------------------
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.color = exports.utils = exports.default = void 0;
var core_legacy_1 = require("./core.legacy");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(core_legacy_1).default; } });
__exportStar(require("./core"), exports);
__exportStar(require("./types"), exports);
__exportStar(require("./options"), exports);
__exportStar(require("./schema"), exports);
exports.utils = __importStar(require("./utils"));
exports.color = __importStar(require("./color"));
